import zhCN from './zh-CN';
export default zhCN;
